// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__sJ-8k"};